import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useLocale } from '@/i18n';

const PromoTicker = () => {
  const t = useLocale();
  const promos = t.promoTicker.messages;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (promos.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % promos.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [promos.length]);

  useEffect(() => {
    if (currentIndex >= promos.length) setCurrentIndex(0);
  }, [promos.length, currentIndex]);

  if (!isVisible || promos.length === 0) return null;

  return (
    <div className="relative bg-earth text-earth-foreground py-2 px-4 text-center text-sm font-medium tracking-wide overflow-hidden">
      <div
        key={currentIndex}
        className="animate-fade-in"
      >
        {promos[currentIndex]}
      </div>
      <button
        onClick={() => setIsVisible(false)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-earth-foreground/60 hover:text-earth-foreground transition-colors rtl:right-auto rtl:left-3"
        aria-label={t.promoTicker.closeLabel}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default PromoTicker;
